import { createContext } from "react";

export const CanadianCriminalLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
